import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subject } from 'rxjs';

import { ButtonDirective } from 'primeng/button';

@Component({
  selector: 'cmg-clear2-ui-manage-borrowers-delete-confirmation-modal',
  templateUrl: './manage-borrowers-delete-confirmation.component.html',
  styleUrls: ['./manage-borrowers-delete-confirmation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonDirective],
})
export class ManageBorrowersDeleteConfirmationModalComponent implements OnInit, OnDestroy {
  private readonly _dialogRef = inject(DynamicDialogRef);
  private readonly _dynamicDialogConfig = inject(DynamicDialogConfig);

  private readonly _destroyed$ = new Subject<boolean>();
  borrowerNames: string[];

  ngOnInit(): void {
    this.borrowerNames = this._dynamicDialogConfig.data;
  }

  ngOnDestroy(): void {
    this._destroyed$.next(true);
    this._destroyed$.complete();
  }

  accept() {
    this._dialogRef.close(true);
  }

  reject() {
    this._dialogRef.close(false);
  }
}
